import { ChangeDetectionStrategy, Component, ElementRef, Output, ViewChild, EventEmitter } from '@angular/core';
import {
  IConfirmationConnection,
  ISldTwoDevicesDevicesConnection,
  SLDConnectionType
} from '../../../enclosure/models/sld.model';

declare var jQuery: any;

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-ui-sld-connection-modal',
    templateUrl: './sld-connection-modal.component.html',
    styleUrls: ['./sld-connection-modal.component.scss'],
    standalone: false
})
export class SldConnectionModalComponent {
  selectedOption = SLDConnectionType.TOP;
  selectedDevices: ISldTwoDevicesDevicesConnection;

  @ViewChild('fromWhereConnectionIsComingModal') connectionModal: ElementRef;

  @Output() confirmSelection = new EventEmitter<IConfirmationConnection>();
  onConfirm() {
    this.confirmSelection.emit({ option: this.selectedOption, devices: this.selectedDevices });
    this.closeModal();
  }

  closeModal() {
    (document.activeElement as HTMLElement)?.blur();
    jQuery(this.connectionModal.nativeElement).modal('hide');
  }

  openModal(devices: ISldTwoDevicesDevicesConnection) {
    this.selectedDevices = devices;
    jQuery(this.connectionModal.nativeElement).modal('show');
  }

  selectOption(option: number) {
    this.selectedOption = option;
  }

}
